import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { DropdownOption } from 'shared-client/types/fields';
import { addSpacesBetweenCaps } from 'util/StringUtil';
import { DropdownProps, FormDropdown } from '.';
import { WithTestIdOptional } from 'shared-client/types/test';

export type EnumDropdownProps = FieldRenderProps<any, HTMLInputElement> &
	DropdownProps &
	WithTestIdOptional & {
		enumType: Record<string, string>;
		addSpaceBetweenCaps?: boolean;
	};

/**
 * Component that renders a dropdown with options.
 *
 * For enumerations used in EnumDropdown:
 * - The enumeration entry's key is used as the *value* for the dropdown entry
 * - The enumeration entry's value is used as the *label* for the dropdown entry
 *
 * @class EnumDropdown
 * @extends {React.Component<EnumDropdownProps>}
 */
class EnumDropdown extends React.Component<EnumDropdownProps> {
	private multiple?: boolean;
	private options: DropdownOption[] = [];
	public static defaultProps: any = {
		indicateDirty: true,
	};

	constructor(props: EnumDropdownProps) {
		super(props);
		this.multiple = props.input.multiple;
		this.options = Object.keys(props.enumType).map((key) => ({
			value: key,
			text: props.addSpaceBetweenCaps ? addSpacesBetweenCaps(props.enumType[key]) : props.enumType[key],
		}));
	}

	public render() {
		// eslint-disable-next-line no-unused-vars
		const { enumType, ...rest } = this.props;
		return (
			<FormDropdown
				{...rest}
				addSelectOption={this.props.addSelectOption}
				options={this.options}
				multiple={this.multiple}
			/>
		);
	}
}

export default EnumDropdown;
